import { ADD_LOGIN_DATA, REMOVE_ITEM, RESET_LOGIN_DATA } from './actionTypes';

export const addloginData = (item:any) => ({
  type: ADD_LOGIN_DATA,
  payload: item,
});

export const removeItem = (id:any) => ({
  type: REMOVE_ITEM,
  payload: id,
});
export const resetLoginData = () => {
  return { type: RESET_LOGIN_DATA };
};